module.exports = __webpack_public_path__ + "img/Speaker=Yash Godiwala.4c02364f.png";